// UserZone.jsx — zona UTENTE della shell (ondata 6): pill iniziali+nome, toggle
// lingua EN/IT, logout. SPOSTATA dal footer del sottomenù (dove viveva in R3 come
// proxy) al fondo del MENU PRINCIPALE: desktop = fondo del Rail (84px: icone +
// tooltip), mobile = fondo del modsheet. UN solo sorgente, due varianti di resa
// ('rail' | 'sheet') — mai due rese divergenti (stessa regola della SubmenuList).
//
// Tutti i controlli sono PROXY dei controlli del #sidebar nascosto del monolite
// (pattern proxyRail già in produzione): bersaglio sparito dal DOM = controllo
// assente alla prossima resa, mai un click nel vuoto.
//  - logout  → #btn-logout (index.html:289): la CONFERMA è del monolite
//              (confirm su common.signout, index.html:17124) — annulla = resta.
//  - lingua  → #sidebar .lang-switch[data-lang] (index.html:293-294). Lo stato
//              ATTIVO si legge da localStorage.crm_ui_lang con default 'it' —
//              ESATTAMENTE la I18N.getLang del monolite (index.html:487): il
//              documentElement.lang NON è affidabile prima del primo
//              applyI18nToDOM (il markup statico dice lang="en").

import React from 'react';
import { label } from './glossary.js';

function initialsOf(user) {
  const s = user && (user.name || user.email);
  if (!s) return '?';
  return s.split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
}

function currentLang() {
  try {
    const v = window.localStorage.getItem('crm_ui_lang');
    if (v === 'en' || v === 'it') return v;
  } catch (e) { /* storage negato: default del monolite */ }
  return 'it'; // parità I18N.getLang: crm_ui_lang || 'it' (index.html:487)
}

// Icona logout (stroke, come le icone del Rail — nessun testo hardcodato).
function OutIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3" />
      <path d="M15 8l4 4-4 4" />
      <path d="M19 12H9" />
    </svg>
  );
}

export function UserZone({ host, variant }) {
  const [, setTick] = React.useState(0);
  const doc = document;
  const user = host.user();
  const langBtn = (l) => doc.querySelector('#sidebar .lang-switch[data-lang="' + l + '"]');
  const hasLang = !!langBtn('en') && !!langBtn('it');
  const hasLogout = !!doc.getElementById('btn-logout');
  if (!user && !hasLang && !hasLogout) return null;

  const lang = currentLang();
  const name = (user && (user.name || user.email)) || '—';
  const role = (user && user.role) || '';
  const sheet = variant === 'sheet';

  function switchLang(l) {
    const b = langBtn(l);
    if (b) b.click(); // switchLanguage del monolite (sincrono: setLang scrive crm_ui_lang) — poi si rilegge
    setTick((t) => t + 1);
  }
  function logout() {
    const b = doc.getElementById('btn-logout');
    if (b) b.click(); // conferma del monolite: annullata ⇒ nessun logout (mai silenzioso)
  }

  return (
    <div className={'uz ' + (sheet ? 'uz-sheet' : 'uz-rail')} aria-label={label('shell.user.aria')}>
      {user && (
        <div className="uz-user" title={name + (role ? ' — ' + role : '')}>
          <span className="uz-ini">{initialsOf(user)}</span>
          {sheet && (
            <span className="uz-id">
              <span className="uz-name">{name}</span>
              <span className="uz-role">{role}</span>
            </span>
          )}
        </div>
      )}
      {hasLang && (
        <div className="uz-langs" role="group" aria-label={label('shell.user.lang_aria')}>
          <button type="button" className={'uz-lang' + (lang === 'en' ? ' active' : '')} onClick={() => switchLang('en')}>
            {label('shell.user.lang_en')}
          </button>
          <button type="button" className={'uz-lang' + (lang === 'it' ? ' active' : '')} onClick={() => switchLang('it')}>
            {label('shell.user.lang_it')}
          </button>
        </div>
      )}
      {hasLogout && (
        <button type="button" className="uz-out" title={label('shell.user.logout')} aria-label={label('shell.user.logout')} onClick={logout}>
          <OutIcon />
          {!sheet && <span className="uz-out-lbl">{label('shell.user.logout')}</span>}
        </button>
      )}
    </div>
  );
}
